import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import spacingStyles from '../shared/styles/_spacing.scss';
import layoutStyles from '../shared/styles/_layout.scss';
export var getLayoutClass = function getLayoutClass(viewport, displayMode) {
  if (!displayMode) {
    return '';
  }

  return layoutStyles["layout-".concat(viewport, "-d-").concat(displayMode)];
};
export var getSpacingClass = function getSpacingClass(type, side, units, viewport) {
  if (!units && units !== 0 || typeof units === 'string') {
    return '';
  }

  var unitsLabel = units.toString().replace('.', '-');
  var viewportLabel = viewport ? "".concat(viewport, "-") : '';
  return spacingStyles["".concat(type, "-").concat(viewportLabel).concat(side, "-").concat(unitsLabel)];
};